
<div
	ref="data-table-wrapper"
	class="flow-data-table flow-add-scrollbar"
	:class="['bar-height-' + scrollBarSize, 'bar-width-' + scrollBarSize]"
	:style="{ maxHeight: maxHeight }"
>
	<table
		ref="data-table"
		@mousemove="handleMouseMove($event)"
		@mouseup="handleMouseUp($event)"
		@mouseleave="handleMouseUp($event)"
	>
		<thead>
			<tr @mouseleave="highlightBorderColumnIdx = -1">
				<th
					v-for="(column, c) in columns"
					:key="column.title"
					nowrap
					:class="{
						sticky: stickyColumn === column.title,
						'highlight-resize': highlightBorderColumnIdx === c
					}"
					:style="{ width: column.width ? column.width : 'auto' }"
					:selected="selectedColumn === c"
					@click="handleColumnClick(0, c)"
					@mousedown="handleMouseDown($event, highlightBorderColumnIdx)"
					@dblclick="resetWidth($event)"
				>
					<div class="display-flex align-items-center flex-gap-12 th-content">
						<div
							class="th-resizer"
							@mouseover="highlightBorderColumnIdx = c - 1"
							@mouseleave="highlightBorderColumnIdx = resizeMeta.pressed ? c - 1 : -1"
						/>
						<slot
							name="header"
							:column="column"
							:columnIndex="c"
							:handleColumnChange="handleColumnChange"
						>
							<Icon
								:name="column.icon.name"
								:size="column.icon.size"
								:state="column.icon.state"
								:type="column.icon.type"
							/><WYSIWYG
								:value.sync="column.title"
								:highlight="true"
								:highlight-state="column.hasError ? 'error' : 'primary'"
								:editable="editColumns && column.editable"
								text-classes="paragraph-2 fc-light text-nowrap"
								@keyup="
									column.hasError = !column.validator(arguments[1]);
									handleColumnChange(column.title, arguments[1], column.hasError, column);
								"
								@change="handleColumnChange(column.title, arguments[0], column.hasError, column)"
								@click.stop=""
							/>
						</slot>
						<div
							v-if="column.sortable"
							class="display-flex flex-d-c margin-lt-auto j-c-c align-items-center sort-icon"
							@click.stop="sortColumn(column.title, innerOrder === 'asc' ? 'desc' : 'asc')"
						>
							<Icon
								name="i-triangle-up"
								size="xx-small"
								type="filled"
								:effects="false"
								:state="
									innerSort === column.title && innerOrder === 'asc' ? 'primary' : 'font-light'
								"
								class="cursor-pointer"
							/>
							<Icon
								name="i-triangle-down"
								size="xx-small"
								type="filled"
								:effects="false"
								:state="
									innerSort === column.title && innerOrder === 'desc' ? 'primary' : 'font-light'
								"
								class="cursor-pointer"
							/>
						</div>
						<div
							class="th-resizer"
							@mouseover="highlightBorderColumnIdx = c"
							@mouseleave="highlightBorderColumnIdx = resizeMeta.pressed ? c : -1"
						/>
					</div>
				</th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="(row, index) in rows" :key="index" @click="handleRowClick(index, row)">
				<td
					v-for="(cell, cid) in row"
					:key="cid"
					:class="{
						sticky: cid == stickyColumnIndex,
						'highlight-resize': highlightBorderColumnIdx === cid
					}"
					:selected="selectedColumn === cid"
					@click="handleColumnClick(index, cid)"
				>
					<!-- @slot Used to display custom column data with any additional components.It has scoped props {column,columnIndex,row,rowIndex} -->
					<slot name="column" :column="cell" :columnIndex="cid" :row="row" :rowIndex="index">
						<div class="padding-12 display-flex align-items-center">
							{{ cell ? cell : "" }}
							<span class="fc-light">{{ cell === null ? "null" : "" }}</span>
							<span class="fc-light">{{ cell === undefined ? "undefined" : "" }}</span>
						</div>
					</slot>
				</td>
			</tr>
		</tbody>
	</table>
	<div v-if="rows && rows.length === 0 && !loading" class="flow-data-table-empty">
		<slot name="empty">
			<EmptyState :hide-icon="true">
				<h4 class="fc-light">No data to display</h4>
			</EmptyState>
		</slot>
	</div>
	<div v-if="loading" class="flow-data-table-loading">
		<slot name="loading">
			<Loader />
		</slot>
	</div>
	<div v-if="noMoreResults && !loading && endOfTableMsg" class="flow-data-table-no-more-results">
		<p class="paragraph-1 fc-dark">End of the table!</p>
	</div>
	<div
		v-if="!noMoreResults && !loadingMore && rows.length !== 0"
		class="flow-data-table-no-more-results cursor-pointer"
	>
		<Button state="outlined" size="small" @click="loadMore(true)"> Load more data </Button>
	</div>
	<div v-if="loadingMore && !noMoreResults" class="flow-data-table-loading-more-results">
		<span class="paragraph-1 fc-primary">Loading more data</span>
		<Icon name="loading" :effects="false" :state="'primary'" />
	</div>
</div>
